export default "__VITE_ASSET__CWrQ9GVx__"